// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import { isRegistrationOpen } from '../config/environment';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <Header />
      
      <div className="home-content">
        {/* Welcome Section */}
        <div className="welcome-section">
          <div className="welcome-text">
            <h1>Welcome to JV Rummy</h1>
            
            {/* Auth Buttons */}
            <div className="auth-buttons">
              <Link to="/login" className="auth-btn login-btn">
                Sign In
              </Link>
              {isRegistrationOpen() && (
                <Link to="/register" className="auth-btn register-btn">
                  Create Account
                </Link>
              )}
              <Link to="/how-to-play" className="auth-btn howto-btn">
                How to Play
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;